<template>
  <div>
    <el-form :model="register" status-icon :rules="rules" ref="register" label-width="100px" class="aa">
      <el-form-item prop="username">
        <el-input type="text" v-model="register.username" placeholder="用户名" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item prop="phone">
        <el-input v-model.number="register.phone" placeholder="手机号"></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input type="password" v-model="register.password" placeholder="密码" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item prop="checkPass">
        <el-input type="password" v-model="register.checkPass" placeholder="再次输入"></el-input>
      </el-form-item>
      <el-form-item prop="code">
        <el-input v-model.number="register.code" placeholder="点击获取">
          <template slot="prepend">验证码</template>
          <el-button slot="append" icon="el-icon-message"
                     :disabled="!show" @click="sendSMS">
          </el-button>
        </el-input>
        <span v-show="count" style="float: right;margin: 12px 52px 0px -49px ;width: 0px">({{count}}s)</span>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('register')" :disabled="!register.checked">注册</el-button>
        <span>已有帐号？去<router-link to="/enter/login">登录</router-link></span>
      </el-form-item>
      <el-form-item>
        <el-checkbox v-model="register.checked">同意XXX协议</el-checkbox>
      </el-form-item>
    </el-form>
      <!--验证码模态框-->
      <Vcode :show="isShow" @success="successShow" @close="closeShow" />

  </div>
</template>

<script>
import Vcode from "vue-puzzle-vcode";
export default {
  name: "Register",
  components:{
    Vcode
  },
  data() {

    var checkUserName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('用户名不能为空'));
      }else{
        callback();
      }


    };
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.register.checkPass !== '') {
          this.$refs.register.validateField('checkPass');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.register.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };

    //手机号校验规则
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'));
      }
      //校验手机号
      var myreg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      setTimeout(() => {
        if (!myreg.test(value)) {
          callback(new Error('请输入正确的手机号'));
        }
        else {
          this.show = true;
          callback();
        }
      }, 1000);
    };

    //验证码校验规则
    var code = (rule, value, callback) => {
      let reg = /^\d{6}$/;
      if(!(reg.test(value))) {
        return callback(new Error('请填写6位数字验证码'));
      }else{
        callback();
      }
    };

    return {

      isShow: false, //控制登录时验证码模态框显示与否
      show: false, //控制发送验证码的按钮显示
      count: '', //短信发送按钮不可用倒计时


      register: {
        username: '',
        password: '',
        checkPass: '',
        phone: '',
        code: '',
        checked:false,
      },

      //校验规则
      rules: {
        username: [
          { validator: checkUserName, trigger: 'blur' }
        ],
        password: [
          { validator: validatePass, trigger: 'blur'}
        ],
        checkPass: [
          { validator: validatePass2, trigger: 'blur' }
        ],
        phone: [
          { validator: checkPhone,trigger: 'change'}
        ],
        code: [
          { validator: code,trigger: 'blur'}
        ]

      }
    };
  },
  methods: {
    sendSMS(){
      //校验手机号
      var myreg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if(!myreg.test(this.register.phone)){
        this.$message.error('请填写正确的手机号');
      }else {
        //点击发送短信验证码,开始图形校验
        this.isShow = true
      }

    },

    successShow(){
      //图形验证码验证成功,关闭模态框
      this.isShow = false

      //禁用短信发送按钮
      const TIME_COUNT = 60 //更改倒计时时间

      this.show = false //按钮不可用
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer); // 清除定时器
            this.timer = null;
          }
        }, 1000)
      }

      this.axios.post('/register/sendSMS/'+this.register.phone+'').then(res=>{
        if(res.data.code === 0){
          //console.log(res.data)
          this.$message(res.data.message)
          this.$message.success('验证码发送成功，请注意查收');
        }else{
          this.$message.error(res.data.message)
        }
      })

    },

    //点击屏幕其他地方,关闭模态框
    closeShow(){
      this.isShow = false
    },

    //点击注册
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var fd = new FormData()
          fd.append("user",JSON.stringify(this.register))
          this.axios.post("/register/inform",fd).then(res => {
            if(res.data.code == 0) {
              this.$message.success("注册成功")
              //清空注册信息
              this.$refs["register"].resetFields()
              //跳转登录
              this.$router.replace("/enter/login")
            }else {
              this.$message.error(res.data.message)
            }
          })
        } else {
          this.$message.warning("信息填写不完整")
          return false;
        }
      });
    }
  }
}
</script>

<style scoped>
.aa >>> .el-form-item__content {
  margin-left:0px !important;
}

.aa >>> .el-input {
  width: 70%;
  margin-top: 3%;
}
.aa >>> .el-form-item__error {
  left: 15%;
}
</style>